"use client";

import { useContentfulInspectorMode } from "@scott/contentful/live-preview-init";
import type { BlockInspectorProps, InspectorProps } from "../../lib/inspector";
import { VideoBlock, type VideoBlockProps } from "./video";

export type VideoBlockInspectorProps = BlockInspectorProps &
  InspectorProps<"video">;

export function VideoBlockPreview(props: Readonly<VideoBlockProps>) {
  const containerInspector = useContentfulInspectorMode({
    entryId: props.sys?.id,
  });

  const headlineInspector = useContentfulInspectorMode({
    entryId: props.headline?.sys?.id,
    locale: props.headline?.sys?.locale,
  });

  return (
    <VideoBlock
      {...props}
      inspectorProps={{
        container: containerInspector({ fieldId: "internalName" }) ?? undefined,
        headline: headlineInspector({ fieldId: "headline" }) ?? undefined,
      }}
    />
  );
}
